import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertStockEntryProduction = createAsyncThunk('insertStockEntryProduction', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertStkProductionwise`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateStockProduction = createAsyncThunk('updateStockProduction', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateStockProduction`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteStockProduction = createAsyncThunk('deleteStockProduction', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=deleteStockProduction`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStockMemoNo = createAsyncThunk('fetchStockMemoNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStockMemoNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchContCuttingRetMemo = createAsyncThunk('fetchContCuttingRetMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getCuttingContractorReturnMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchKajeEmplistsdf = createAsyncThunk('fetchKajeEmplistsdf', async (id) => {
    try {
        const endpoint = id ? `getKajeEmplist&empId=${id}` : 'getKajeEmplist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStkReturnBarcode = createAsyncThunk('fetchStkReturnBarcode', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStockReturnBarcode`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchStkProductionReg = createAsyncThunk('fetchStkProductionReg', async (id) => {
    try {
        const endpoint = id ? `getStkProductionReg&stkId=${id}` : 'getStkProductionReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const stockApiSlice = createSlice({
    name: 'StockDatalist',
    initialState: {
        isLoading: false,
        stkMemo: null,
        stkbar: null,
        contCutRetmemo: null,
        stkReg: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStockMemoNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStockMemoNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stkMemo = action.payload;
        });
        builder.addCase(fetchStockMemoNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchStkReturnBarcode.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStkReturnBarcode.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stkbar = action.payload;
        });
        builder.addCase(fetchStkReturnBarcode.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchContCuttingRetMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchContCuttingRetMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.contCutRetmemo = action.payload;
        });
        builder.addCase(fetchContCuttingRetMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchStkProductionReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStkProductionReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stkReg = action.payload;
        });
        builder.addCase(fetchStkProductionReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default stockApiSlice.reducer;
